"use client"

import { createRoute, redirect } from "@tanstack/react-router"

import { isBackendConversationId } from "@/components/agentic-ats/robin/utils/conversation-presenter"
import AuthenticatedRoute from "@/rootRoutes/AuthenticatedRoute"

function EmptyRoute() {
  return null
}

/**
 * Legacy `/agentic-ats-demo` routes. The conversation now lives in `?c=` on the
 * ATS routes, so old links are translated rather than dropped.
 *
 * Deliberately no `beforeLoad` here: parent `beforeLoad` runs before the child's,
 * so a redirect at this level would fire first and discard `$conversationId`. The
 * bare path is handled by the index child instead.
 */
const AgenticAtsLegacyRedirectPage = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: "/agentic-ats-demo",
  component: EmptyRoute,
})

export const AgenticAtsLegacyIndexRedirect = createRoute({
  getParentRoute: () => AgenticAtsLegacyRedirectPage,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", replace: true })
  },
  component: EmptyRoute,
})

export const AgenticAtsLegacyConversationRedirect = createRoute({
  getParentRoute: () => AgenticAtsLegacyRedirectPage,
  path: "$conversationId",
  beforeLoad: ({ params }) => {
    const { conversationId } = params
    throw redirect({
      to: "/dashboard",
      search: isBackendConversationId(conversationId)
        ? { c: conversationId }
        : undefined,
      replace: true,
    })
  },
  component: EmptyRoute,
})

export default AgenticAtsLegacyRedirectPage
